<lib-image-field label="Digital Wallet" [fontImage]="digitalWalletFontImage">
    <ng-container *ngIf="!digitalWalletFontImage && digitalWalletImageFile">
        <img [src]="digitalWalletImageFile" height="32px" style="margin-top: -5px;" />
    </ng-container>
</lib-image-field>
